// extracted by mini-css-extract-plugin
export default {"root":"_3ZkW5","text-block":"_2gGjF","textBlock":"_2gGjF","prefix":"_267dY"};